import { render, staticRenderFns } from "./NurseDetailsView.vue?vue&type=template&id=56e02f0d"
import script from "./NurseDetailsView.vue?vue&type=script&lang=js"
export * from "./NurseDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports